/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import controlled_inputImg from 'assets/images/controlled_input.jpg'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Контролируемый элемент</h2>
    <p className={styles.description}>
      Основная цель любой формы - получить данные пользователя. Элементы формы это контроллируемые компоненты, значения
      всех полей должны быть в <code className={styles.code}>state</code>.{' '}
    </p>
    <p className={styles.description}>Паттерн работы с элементами форм очень простой. </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Поле в <code className={styles.code}>state</code> определяет значение атрибута{' '}
        <code className={styles.code}>value</code> инпута
      </li>
      <li className={styles.list__item}>
        Событию <code className={styles.code}>onChange</code> передается метод изменяющий поле в состоянии
      </li>
    </ul>
    <p className={styles.description}>Получаем замкнутый круг. </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        При событии <code className={styles.code}>onChange</code>, метод класса обновляет поле в состоянии{' '}
      </li>
      <li className={styles.list__item}>При изменении состояния происходит ре-рендер </li>
      <li className={styles.list__item}>Инпут отображается с обновленными данными </li>
    </ul>
    <img className={styles.img} src={controlled_inputImg} alt="controlled_input" />
    <CopyBlock
      text={`class App extends Component {
  state = {
    value: '',
  };

  handleChange = e => {
    this.setState({ value: e.target.value });
  };

  render() {
    const { value } = this.state;

    return <input type="text" value={value} onChange={this.handleChange} />;
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Получается что не интерфейс определяет какие у нас данные, а наоборот, данные определяют то, что видит
      пользователь, обновляя DOM при изменении состояния компонента.{' '}
    </p>
  </section>
))
